import { useNavigate } from 'react-router-dom'

export const MENU_URL = '/menu'

export const useMenuPageNavigator = () => {
  const navigate = useNavigate()

  return {
    go: () => {
      navigate(MENU_URL)
    }
  }
}
